import { nextDate } from "./nextDate";
import { setNextRefresh } from "../../utilities/nextRefresh";
import { getActiveService, setActiveService, } from "../../utilities/activeService";
import { refreshCallback } from "./refreshCallback";
import { startTimer } from "./startTimer";
/* SET SERVICE REFRESHES BASED ON TIMES GIVEN */
export function refreshService(service, status, date) {
    if (!service.date && service.date < date) {
        // if service.date doesn't exist we can't keep going at this point
        // if it does exist we don't want to continue if the service.date is in the past.
        return;
    }
    const serviceInt = service.repeat;
    const beforeServiceRefresh = service.beforeRefresh || 30; // refresh 30 minutes before services start by default unless otherwise specified.
    service.refreshDate = nextDate(serviceInt, service.day, service.time, service.period);
    // TODO: Can we simplify the logic here to determine the refreshDate?
    if (service.date) {
        // if a service.date is used, and it's in the future use that value minus the beforeServiceRefresh amount
        // otherwise we can use the original repeated refreshDate
        const funcRefreshDate = new Date(service.date.valueOf() - 1000 * 60 * beforeServiceRefresh);
        service.refreshDate =
            service.refreshDate < funcRefreshDate
                ? funcRefreshDate
                : service.refreshDate;
    }
    const activeService = getActiveService();
    // TODO: has to be here because we only just defined the refreshDate
    if (!activeService ||
        (date < service.refreshDate &&
            service.refreshDate < activeService.refreshDate)) {
        setActiveService(service); // set before we set with refresh adjustment
    }
    service.refreshDate.setMinutes(service.refreshDate.getMinutes() - beforeServiceRefresh); // adjust for refresh
    if (status) {
        // TODO: how is this different than the active service? 30 minutes before?
        setNextRefresh(service.refreshDate);
        startTimer(false, service.refreshDate, serviceInt, false, refreshCallback);
    }
}
